export const addAlertRespondersToGroupBulkActionType = 'addAlertRespondersToGroup';
